var $8eeb1c35d0764ab5$exports = {};
$8eeb1c35d0764ab5$exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{7D22}`
};


export {$8eeb1c35d0764ab5$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
